import React, { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  apiKey?: string;
  showApiKey?: boolean;
  error?: string;
  hint?: string;
  children: ReactNode;
}

export function FormField({
  label,
  htmlFor,
  apiKey,
  showApiKey = false,
  error,
  hint,
  children,
}: FormFieldProps) {
  return (
    <div className="mb-3">
      <label htmlFor={htmlFor} className="form-label fw-semibold">
        {label}
        {showApiKey && apiKey && (
          <>
            {' '}
            <span className="text-muted fw-normal small">
              (
              {apiKey}
              )
            </span>
          </>
        )}
      </label>
      {children}
      {hint && !error && <div className="form-text">{hint}</div>}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
